import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MessengerGradient = () => /*#__PURE__*/_jsx("svg", {
  style: {
    width: 0,
    height: 0,
    position: 'absolute'
  },
  "aria-hidden": "true",
  focusable: "false",
  children: /*#__PURE__*/_jsxs("radialGradient", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: "19.2474387%",
    cy: "99.4651948%",
    fx: "19.2474387%",
    fy: "99.4651948%",
    r: "108.959588%",
    id: "messengerGradient",
    children: [/*#__PURE__*/_jsx("stop", {
      stopColor: "#0099FF",
      offset: "0%"
    }), /*#__PURE__*/_jsx("stop", {
      stopColor: "#A033FF",
      offset: "60.9753877%"
    }), /*#__PURE__*/_jsx("stop", {
      stopColor: "#FF5280",
      offset: "93.482299%"
    }), /*#__PURE__*/_jsx("stop", {
      stopColor: "#FF7061",
      offset: "100%"
    })]
  })
});
//# sourceMappingURL=MessengerGradient.js.map